export const SWAG_APOLLO_CLIENT = 'SWAG';
export const GIRA_APOLLO_CLIENT = 'gira';
export const REST_APOLLO_CLIENT = 'REST';
export const JPD_APOLLO_CLIENT = 'POLARIS';
